window.setActiveSidebar = function(params) {
  if (params.dom.closest("#sidebar-menu").length == 0) {
    return true;
  }
  $("#sidebar-menu a[class='active']").each(function(idx, elm){
    $(elm).removeClass('active')
  })

  $("#sidebar-menu a[class='active subdrop']").each(function(idx, elm){
    $(elm).removeClass('active')
    $(elm).removeClass('subdrop')
  })

  params.dom.addClass("active")
}